import { round as r } from 'lodash'


const round = (num, precision=1) => {
	if(isNaN(num)) {
		return 0
	}
	if(num === '') {
		return ''
	}
    return r(num, precision)
}

const giveRandom = (num) => {
    return num === 0 ?  Math.floor(Math.random() * 21) : num
}

const currency = (value, currencyType = 'USD', fractionDigits = 0 ) => {

	let number = Number(value)

	let currencyCode = currencyType

	try{
		let formatedNumber = (number).toLocaleString('en-US', {style: 'currency', currency: currencyCode, minimumFractionDigits:fractionDigits})
		if(fractionDigits === 0){
			if(formatedNumber.indexOf('.') !== -1){
				formatedNumber = formatedNumber.split('.')[0]
			}
		}

		return formatedNumber
	}
	catch(error){
		return `${currencyType ? currencyType : ''} ${(number).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
	}

}

const handleCurrency = tableCurrency => {
	if(tableCurrency === '' || tableCurrency === undefined) {
		return null
	}
	const stringCurrency = tableCurrency.replace(/[, ]/g,'')
	if(!!stringCurrency[0].match(/[0-9]/g)) {
		return parseInt(stringCurrency)
	}
	else {
		return parseInt(stringCurrency.slice(1))
	}
}

const hasColumn = (columns, columnName) => {
	let columnExist = false;

	if(columns !== null){
		if(columnName === 'nSummary'){
			columnExist = true;
		}else{
			Object.keys(columns).forEach(column => {
				if(column === columnName){
					if(columns[column] === 1){
						columnExist = true
					}
				}
			})
		}
	}

	return columnExist
}

export {
    round,
	giveRandom,
	currency,
	hasColumn,
	handleCurrency
}
